  <template>
  <div class="subNews">
    <v-header />
    <!-- <div style="height; auto;"> -->
      <div class="newss" v-for="(item,index) in newList" :key="index">
        <!-- <router-link :to="{path:'/newsIndexDetail',query:{news:item}}"> -->
        <div @click="NewsDetail(item.id,item.type)">
          <div class="left">
           <img :src="item.imageUrl" />
          </div>
          <div class="right">
            <div class="title">{{item.title}}</div>
            <div class="content">导语：{{item.summary}}</div>
            <div class="date">{{item.createTime*1000 | formatDate}}</div>
          </div>
        </div>
        <!-- </router-link> -->
        <!-- <div class="line"></div> -->
      </div>
      <!-- <div class="more" @click="getMore">
        <p v-if="isMore">查看更多>></p >
        <p v-else>全部加载完毕...</p >
      </div> -->

      <infinite-loading direction="bottom" :distance="distance" @infinite="infiniteHandler">
          <span slot="no-results" style="padding-bottom:50px;">没有更多了～</span>
          <span slot="no-more">没有更多了～</span>
      </infinite-loading>
    <!-- </div> -->

  </div>
</template>

<script>
import VHeader from "./header/VHeader";
import InfiniteLoading from "vue-infinite-loading";

export default {
  // props: ["navID"],
  metaInfo: {
  meta: [{
      name: 'keywords',
      content: '51Testing,软件测试,软件测试培训,公司新闻',
    },{
      name: 'description',
      content: '汇聚公司新闻,合作动态,班级活动,学员心得,视频广场等51Testing软件测试培训网的最新资讯.',
    }]
  },
   components: {
    VHeader,   
    InfiniteLoading
  },
  data() {
    return {
      newList: [],
      isShow: true,
      distance: 100,
      count: 4,
      isMore: true
    };
  },
  watch: {
    navID: {
      handler: function() {
        if (this.navID === 1) {
          this.isShow = true;
        } else {
          this.isShow = false;
        }
      },
      immediate: true
    },
    count: {
      handler: function() {
        if (this.count > this.newList.count) {
          this.isMore = false;
        }
        // this.getNews();
      },
      immediate: true
    }
  },
   mounted() {
    // this.count = 4;
  },
  methods: {
    NewsDetail(id,type){
       this.$router.push({ path: `/newsIndex/company/${id}.html` });
    },
     infiniteHandler($state) {
      this.axios
        .get("/api/consume/Information/PageList", {
          params: {
            Type: 1,
            rows: this.count
          }
        })
        .then(res => {
          if(res.data.results.length >= res.data.count){
              $state.complete();
              return;
          }
          this.newList = res.data.results;
          this.count+= 4;
          $state.loaded();
        });
    }
    // getMore() {
    //   this.count += 4;
    // }, 
  },
 
}
</script>

<style scoped>
.subNews .newss {
  /* margin-left: 30px; */
  overflow: hidden;
  padding-top: 34px;
  clear: both;
  padding-left: 30px;
  padding-right: 30px;
  background: #ffffff;
  margin-top: 10px;
}
.subNews .left {
  float: left;
  overflow: hidden;
}
.subNews .right {
  float: left;
  width: 65%;
}
.subNews .left img {
  width: 240px;
  height: 170px;
  border-radius: 10px;
}
.subNews .right .title {
  /* border-bottom:0.1px #bfbfbf solid; */
  margin-bottom: 7px;
  font-size: 26px;
  color: #444444;
  margin-left: 20px;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  overflow: hidden;
  width: 400px;
  font-weight: normal;
}
.subNews .right .content {
  font-size: 22px;
  color: #8b8b8b;
  margin-left: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  padding-top: 7px;
  border-top: 1px #e2e2e2 solid;
  width: 94%;
  line-height: 32px;
}
.subNews .more {
  padding: 39px 0;
}
.subNews .more p {
  color: #747474;
  font-size: 26px !important;
  text-align: center;
}
.date {
  color: #e2e2e2;
  font-size: 22px;
  clear: both;
  margin-left: 20px;
  margin-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/Studycenter.vue